import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {wait} from '@/utils/wait';
import moment from 'moment';
import {fetchList, getAllExpList, releasePurchase} from '@/api/sms/error-order';
import {Message} from "element-ui";

export default extend(table, {
	namespaced: true,
	state: {
		expList: {},
		searchForm: {}
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'scm.error-order.list', async function () {
				const {searchForm} = state;
				const params = {
					processType: searchForm.processType,
					expType: searchForm.expType,
					suppName: searchForm.suppName,
					searchType: searchForm.searchType,
					searchValue: searchForm.searchValue
				}
				if (searchForm.timeSelect && searchForm.timeValue.length > 0) {
					const startTime = searchForm.timeValue[0] && Math.round(moment(searchForm.timeValue[0]).startOf('day').valueOf() / 1000)
					const endTime = searchForm.timeValue[1] && Math.round(moment(searchForm.timeValue[1]).endOf('day').valueOf() / 1000)
					if (searchForm.timeSelect === 'createTime') {
						params.startTime = startTime
						params.endTime = endTime
					}else if(searchForm.timeSelect === 'deliveryTime'){
						params.deliveredStartTime = startTime
						params.deliveredEndTime = endTime
					}
				}
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...params,
						...payload,
					}
				});
			})
		},
		async getAllExpList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'scm.error-order.all-exp', async function () {
				const response = await getAllExpList();
				if (response.data) {
					commit('save', {
						expList: response.data.expType
					})
				}
			})
		},
		async releasePurchase({state, dispatch}, multipleSelection) {
			if (multipleSelection.length <= 0) {
				return Message.error('至少勾选一个采购需求');
			}
			await wait(dispatch, 'scm.error-order.release', async function () {
				await releasePurchase({
					recIds: multipleSelection.map((v) => {
						return v.recId;
					})
				});
				Message.success('操作成功');
			})
			dispatch('getList')
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/scm/error-order/list.js